export default __webpack_public_path__ + "static/media/66t.af976d87.jpg";